<template>

</template>

<script>
export default {
  name: "otherView"
}
</script>

<style scoped>

</style>